import { createRoot } from 'react-dom/client';

import './app/services/i18n';

import App from './app/App';

// Handle a weird Safari bug where cached data could load on back button
// eslint-disable-next-line @stylistic/max-len
// https://stackoverflow.com/questions/8788802/prevent-safari-loading-from-cache-when-back-button-is-clicked#answer-13123626
window.onpageshow = function(event) {
  if (event.persisted) {
    window.location.reload();
  }
};

const container = document.getElementById('root');

if (!container) {
  throw new Error('Unable to find root element');
} else {
  const root = createRoot(container);
  root.render(<App />);

  import.meta.hot?.accept();
}
